import React, { useEffect, useState } from "react";
import styles from "./DialogFWIntegrationForm.module.scss";
import SaveIcon from "../../assets/icons/SaveIcon";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { DialogFormIcon } from "../../assets/icons/DialogFormIcon";
import Input from "../../ui/Input/Input";
import Select from "../../ui/Select/Select";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setNewDialogsFW } from "../../store/slices/dialogFormWidgetSlice";
import { ColorPickersDWF, FormPreview } from "./components";
import { validateDialogFWFields } from "../../utils/methods/validationField";
import { ClipLoader } from "react-spinners";
import { createAssistantForm } from "../../utils/api/actions/integrations/assistantForm";

export const DialogFWIntegrationForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { activeAssistant } = useSelector((state) => state?.assistant);
  const { dataAssistants } = useSelector((state) => state?.assistant);
  const { newDialogFormWidget } = useSelector((state) => state?.dialogWF);
  const user = useSelector((state) => state?.user?.data);
  const assistants = useSelector((state) => state.assistant.dataAssistants);

  const [loading, setLoading] = useState(false);

  const userId = user?.id;

  const errorFields = (messages) => {
    toast.dismiss("customId");
    messages.forEach((message) =>
      toast.error(message, { toastId: "customId" })
    );
  };
  const errorCreate = (message) =>
    toast.error(message, {
      toastId: "customId",
    });

  const isEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

  useEffect(() => {
    if (!newDialogFormWidget) {
      dispatch(
        setNewDialogsFW({
          userId,
          assistantId: assistants ? assistants[0].id : "",
          assistantName: assistants ? assistants[0].name : "",
          allowedDomains: "",
          widgetColor: "#ffffff",
          widgetTextColor: "#000000",
          widgetBorderColor: "#d4d4d4",
          widgetInputColor: "#000000",
          widgetButtonColor: "#2088f7",
          widgetButtonDisabledColor: "#9e9e9e",
        })
      );
    }
  }, [assistants, dispatch, newDialogFormWidget, userId]);

  const handlerInput = (e) => {
    if (newDialogFormWidget) {
      let res = JSON.parse(JSON.stringify(newDialogFormWidget));

      Object.defineProperty(res, e.target.name, {
        value: e.target.value,
      });

      dispatch(setNewDialogsFW(res));
    }
  };

  const selectObserver = (val) => {
    if (newDialogFormWidget) {
      let res = JSON.parse(JSON.stringify(newDialogFormWidget));

      Object.defineProperty(res, "assistantId", {
        value: val,
      });

      const selectedAssistant = dataAssistants.find(
        (assistant) => assistant.id === val
      );
      Object.defineProperty(res, "assistantName", {
        value: selectedAssistant ? selectedAssistant.name : "",
      });

      dispatch(setNewDialogsFW(res));
    }
  };

  const handleSave = () => {
    if (isEmptyObject(newDialogFormWidget)) {
      if (validateDialogFWFields(newDialogFormWidget, errorFields)) {
        let data = {
          userId,
          name: newDialogFormWidget.assistantName,
          assistantId: newDialogFormWidget.assistantId,
          allowedDomains: newDialogFormWidget.allowedDomains,
        };
        dispatch(createAssistantForm(data, navigate, errorCreate, setLoading));
      }
    }
  };

  const handleCancel = () => {
    dispatch(setNewDialogsFW(null));
    navigate("/integration");
  };

  const actions = [
    {
      title: "Сохранить",
      icon: loading ? <ClipLoader size={12} color="white" /> : <SaveIcon />,
      className: styles.addButton,
      titleClassName: styles.titleAddButton,
      onClick: handleSave,
    },
    {
      title: "Отмена",
      className: styles.cancelButton,
      titleClassName: styles.titleCancelButton,
      onClick: handleCancel,
    },
  ];

  return (
    <div className={styles.mainContainer}>
      <ScreenHeader
        actions={actions}
        title={
          <>
            Новая интеграция <DialogFormIcon size={25} fill={"#151515"} />
          </>
        }
      />
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <Select
            containerStyle={styles.containerSelect}
            labelStyle={styles.labelSelect}
            dataSelect={dataAssistants}
            title="Выберите ассистента"
            selectObserver={selectObserver}
            settings={activeAssistant?.settings}
            nameSelectedOption={"Ассистент"}
          />
          <div className={styles.inputContainer}>
            <Input
              className={styles.child}
              label={"Введите имя ассистента"}
              labelStyle={styles.labelInput}
              backgroundStyle={styles.labelBackground}
              inputStyle={styles.input}
              value={
                newDialogFormWidget ? newDialogFormWidget?.assistantName : ""
              }
              name={"assistantName"}
              onChange={handlerInput}
              type={"text"}
              placeholder={"Имя ассистента"}
            />
          </div>
          <div className={styles.inputContainer}>
            <Input
              className={styles.child}
              label={"Доверенные домены"}
              labelStyle={styles.labelInput}
              backgroundStyle={styles.labelBackground}
              inputStyle={styles.input}
              value={
                newDialogFormWidget ? newDialogFormWidget.allowedDomains : ""
              }
              name={"allowedDomains"}
              onChange={handlerInput}
              type={"text"}
              placeholder={"sm.tab-is.com"}
            />
          </div>
          <ColorPickersDWF />
        </div>
        <FormPreview />
      </div>
    </div>
  );
};
